import {
  SET_LOADER,
  RESET_LOADER,
} from '../mutation-types'

const loaderState = {
  status: false,
}

const mutations = {
  [SET_LOADER] (state) {
    state.status = true
  },

  [RESET_LOADER] (state) {
    state.status = false
  },
}

const actions = {
  setLoader ({ commit }) {
    commit(SET_LOADER)
  },
  resetLoader ({ commit }) {
    commit(RESET_LOADER)
  },
}

export default {
  namespaced: true,
  state: loaderState,
  mutations,
  actions,
}
